import { isAvatarBig } from '@amplify/avatar-builder';

import { MIDDLE_SCHOOL_GRADES } from 'src/constants/grades.constants';
import { GRADES } from 'src/interfaces/grades.types';
import AuthService from 'src/services/api/auth.service';
import {
  saveAvatarConfig,
  useAvatarConfigSelector,
} from 'src/store/features/avatar.slice';
import { useAppDispatch } from 'src/store/redux';

export const useAvatar = (grade: GRADES) => {
  const {
    bigAvatarConfig,
    smallAvatarConfig,
    teacherAvatarConfig,
    msStudentAvatarConfig,
  } = useAvatarConfigSelector();

  const dispatch = useAppDispatch();

  const isBig = isAvatarBig(grade);
  const isTeacher = AuthService.isTeacher();
  const isMsStudent = !isTeacher && MIDDLE_SCHOOL_GRADES.includes(grade);

  const getCharacterAssets = () => {
    if (isTeacher) return teacherAvatarConfig;

    if (isMsStudent) return msStudentAvatarConfig;

    return isBig ? bigAvatarConfig : smallAvatarConfig;
  };

  const saveAvatar = (characterAssets: unknown, isBigReceived?: boolean) => {
    if (isTeacher) {
      dispatch(
        saveAvatarConfig({
          configType: 'teacherAvatarConfig',
          avatarConfig: characterAssets,
        }),
      );
    }

    if (isMsStudent) {
      dispatch(
        saveAvatarConfig({
          configType: 'msStudentAvatarConfig',
          avatarConfig: characterAssets,
        }),
      );
    }

    const isBigK5Student = isBigReceived ?? isBig;

    return isBigK5Student
      ? dispatch(
          saveAvatarConfig({
            configType: 'bigAvatarConfig',
            avatarConfig: characterAssets,
          }),
        )
      : dispatch(
          saveAvatarConfig({
            configType: 'smallAvatarConfig',
            avatarConfig: characterAssets,
          }),
        );
  };

  return {
    saveAvatar: saveAvatar,
    characterAssets: getCharacterAssets(),
  };
};
